module.exports = __webpack_public_path__ + "static/media/Mask Group 22.a816d28f.svg";